import React from 'react';
import { SimpleDropDownElement } from 'components/simple-dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ShareButton = ({ hidden, disabled, onClick, icon, customIcon, label, dataE2e }) =>
  hidden ? null : (
    <div data-e2e={dataE2e}>
      <SimpleDropDownElement onClick={onClick} disabled={disabled}>
        {customIcon && customIcon}
        {icon && <FontAwesomeIcon icon={icon} />}
        {label}
      </SimpleDropDownElement>
    </div>
  );
